import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=a6470892&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/sass/style_custom.scss?vue&type=style&index=0&id=a6470892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6470892",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6470892')) {
      api.createRecord('a6470892', component.options)
    } else {
      api.reload('a6470892', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=a6470892&scoped=true&", function () {
      api.rerender('a6470892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/pages/report/OrderDetail.vue"
export default component.exports